import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaCheck, FaSave, FaCube } from 'react-icons/fa';
import Sidebar from './Sidemenu';



const NewCampaign = ({ setSavedDetails }) => {
  const [campaignDetails, setCampaignDetails] = useState({
    name: '',
    description: '',
  });

  const navigate = useNavigate();

  const handleCancel = () => {
    console.log('Cancel button clicked');
  };

  const handleApply = () => {
    console.log('Apply button clicked');
  };

  const handleSaveAndClose = async () => {
    try {
      console.log('Details saved:', campaignDetails);
      alert('Details saved successfully!');

      // Save campaign details in the state
      const newSavedDetails = {
        name: campaignDetails.name,
        description: campaignDetails.description,
      };

      // Pass the details to the parent component (App.js)
      setSavedDetails(newSavedDetails);

      // Clear the form fields and navigate to the campaigns page
      setCampaignDetails({ name: '', description: '' });
      navigate('/campaigns');
    } catch (error) {
      console.error('An error occurred during save and close:', error);
    }
  };

  const handleLaunchCampaignBuilder = () => {
    console.log('Launch Campaign Builder button clicked');
    // Use the navigate function to go to the CampaignBuilder page
    navigate('/campaignbuilder');
  };

  return (

    <div style={{ display: 'flex' }}>
    
    <Sidebar />
    <div className="segment-container">
  <div className="header mt-5" style={{ display: 'flex', alignItems: 'center' }}>
    <h1 style={{ marginLeft: '5%', flex: '1',width:'350px' }}>New Campaign</h1>
    <div className="action-buttons" style={{ display: 'flex', gap: '1px' }}>
      <button className="cancel-button" onClick={handleCancel} style={{ flexShrink: 0 }}>
        <FaTimes /> Cancel
      </button>
      <button className="apply-button" onClick={handleApply} style={{ flexShrink: 0 }}>
        <FaCheck /> Apply
      </button>
      <button className="save-button" onClick={handleSaveAndClose} style={{ flexShrink: 0 }}>
        <FaSave /> Save & Close
      </button>
      <button className="launch-button" onClick={handleLaunchCampaignBuilder} style={{ flexShrink: 0 }}>
        <FaCube style={{ marginRight: '5px' }} /> Launch Campaign Builder
      </button>
    </div>
  </div>






  <div className="content" style={{ width: '100%', padding: '20px', boxSizing: 'border-box' }}>
  {/* Campaign Details */}
  <div>
  <div className="details-content form-row mb-5">
    
      <label htmlFor="name">Name:</label>
      <input
        type="text"
        id="name"
        className="form-control" style={{ marginTop: '50px',width:'500px',marginBottom:'20px',marginLeft:'-50px'}}
        value={campaignDetails.name}
        onChange={(e) => setCampaignDetails({ ...campaignDetails, name: e.target.value })}
      />
    </div>
  

  <div className="details-content form-row mb-5">
  
      <label htmlFor="description">Description:</label>
      <textarea
        id="description"
        className="form-control" style={{ marginTop: '50px',marginBottom:'60px',width:'500px',marginLeft:'-90px'}}
        value={campaignDetails.description}
        onChange={(e) => setCampaignDetails({ ...campaignDetails, description: e.target.value })}
      ></textarea>
    </div>
  
</div>

      </div>
    


        </div>
      </div>
    
  );
};

export default NewCampaign;
